// Réglages cachés (socle UX, section 3) : double clic ou double appui sur « 0cog™ » dans les mentions légales (ui/settingsSecret.js),
// en fenêtre plein écran. Chaque changement est appliqué en aperçu par
// un callback ; il n'est gardé que par « Enregistrer » (barre du bas, à droite), « Annuler » et toute autre fermeture l'abandonnent (voir game.js).
// L'onglet Général est un formulaire compact (liste déroulante ou interrupteur par ligne) : langue, animations réduites, version iOS, et deux
// actions qui ne partent qu'à « Enregistrer » : revoir les astuces, réinitialiser la partie. Les réglages de jeu (curseurs) viennent ensuite.
import { $ } from './dom.js';
import { createDialog } from './dialog.js';
import { createSettingsTabs, GENERAL_TAB } from './settingsTabs.js';

/**
 * @param {object} deps
 * @param {(key: string, params?: object) => string} deps.t
 * @param {{ populate: Function }} deps.game  curseurs de réglages de jeu (ui/devSettings.js)
 * @param {{ onLang: Function, onReducedMotion: Function, onIos: Function, onActions: Function,
 *   onResetSettings: Function, onSave: Function }} deps.handlers
 */
export function createSettingsDialog({ t, game, handlers }) {
  const lang = $('settingsLang');
  const reduced = $('settingsReducedMotion');
  const ios = $('settingsIos'); // version iOS (simulation) : une charge rapide offerte par niveau
  const replayTips = $('settingsReplayTips'); // action à l'enregistrement : rouvrir les astuces
  const resetGame = $('settingsResetGame'); // action à l'enregistrement : réinitialiser la partie
  const dialog = createDialog($('settingsOverlay'));
  const tabs = createSettingsTabs($('settingsOverlay')); // onglets en paysage seulement (voir main.css)

  lang.addEventListener('change', () => handlers.onLang(lang.value));
  reduced.addEventListener('change', () => handlers.onReducedMotion(reduced.checked));
  ios.addEventListener('change', () => handlers.onIos(ios.checked));
  $('btnResetSettings').addEventListener('click', () => handlers.onResetSettings());
  const actions = () => ({ replayTips: replayTips.checked, resetGame: resetGame.checked });
  for (const toggle of [replayTips, resetGame]) toggle.addEventListener('change', () => handlers.onActions(actions()));
  // Barre du bas : « Enregistrer » garde tout ce qui a changé (grisé tant que rien n'a changé), « Annuler » abandonne
  const btnSave = $('btnSaveSettings');
  const dirtyNote = $('settingsDirty');
  btnSave.addEventListener('click', () => { handlers.onSave(); dialog.close(); });
  $('btnCancelSettings').addEventListener('click', () => dialog.close());
  function setDirty(dirty) {
    btnSave.disabled = !dirty;
    dirtyNote.hidden = !dirty;
  }
  /** Resynchronise les contrôles du socle avec l'état courant (à l'ouverture, et au changement de langue ou de lieu). */
  function sync({ language, reducedMotion, ios: iosOn }) {
    lang.value = language;
    reduced.checked = !!reducedMotion;
    ios.checked = !!iosOn;
  }

  return {
    /** @param {{ language: string, reducedMotion: boolean, ios: boolean, settings: object, batteryPercent: number }} snapshot */
    open(snapshot) {
      sync(snapshot);
      replayTips.checked = false; // les deux actions repartent éteintes à chaque ouverture
      resetGame.checked = false;
      game.populate(snapshot.settings, snapshot.batteryPercent);
      setDirty(false);
      tabs.select(GENERAL_TAB);
      return dialog.open();
    },
    sync,
    setDirty,
    close: dialog.close,
    isOpen: dialog.isOpen,
  };
}
